const de = {
  // ============================================================
  // COMMON — Gemeinsam in der gesamten Anwendung
  // ============================================================
  common: {
    loading: 'Laden...',
    error: 'Fehler',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    close: 'Schließen',
    confirm: 'Bestätigen',
    apply: 'Anwenden',
    reset: 'Zurücksetzen',
    search: 'Suchen',
    filter: 'Filtern',
    clear: 'Leeren',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    submit: 'Absenden',
    update: 'Aktualisieren',
    refresh: 'Aktualisieren',
    export: 'Exportieren',
    import: 'Importieren',
    download: 'Herunterladen',
    upload: 'Hochladen',
    print: 'Drucken',
    copy: 'Kopieren',
    yes: 'Ja',
    no: 'Nein',
    ok: 'OK',
    done: 'Fertig',
    select: 'Auswählen',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    noResults: 'Keine Ergebnisse gefunden',
    noData: 'Keine Daten verfügbar',
    required: 'Erforderlich',
    optional: 'Optional',
    actions: 'Aktionen',
    details: 'Details',
    overview: 'Übersicht',
    summary: 'Zusammenfassung',
    total: 'Gesamt',
    all: 'Alle',
    none: 'Keine',
    name: 'Name',
    type: 'Typ',
    status: 'Status',
    date: 'Datum',
    time: 'Zeit',
    description: 'Beschreibung',
    notes: 'Notizen',
    comments: 'Kommentare',
    category: 'Kategorie',
    priority: 'Priorität',
    nation: 'Nation',
    country: 'Land',
    email: 'E-Mail',
    phone: 'Telefon',
    address: 'Adresse',
    location: 'Standort',
    coordinates: 'Koordinaten',
    latitude: 'Breitengrad',
    longitude: 'Längengrad',
    from: 'Von',
    to: 'Bis',
    createdAt: 'Erstellt',
    updatedAt: 'Aktualisiert',
    createdBy: 'Erstellt von',
    modifiedBy: 'Geändert von',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    showing: 'Anzeige',
    of: 'von',
    page: 'Seite',
    perPage: 'pro Seite',
    rows: 'Zeilen',
    items: 'Einträge',
    results: 'Ergebnisse',
    sortBy: 'Sortieren nach',
    ascending: 'Aufsteigend',
    descending: 'Absteigend',
    viewAll: 'Alle anzeigen',
    viewDetails: 'Details anzeigen',
    goBack: 'Zurück',
    learnMore: 'Mehr erfahren',
    seeMore: 'Mehr anzeigen',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    expandAll: 'Alle aufklappen',
    collapseAll: 'Alle zuklappen',
    copied: 'Kopiert!',
    saved: 'Gespeichert!',
    deleted: 'Gelöscht!',
    updated: 'Aktualisiert!',
    created: 'Erstellt!',
    success: 'Erfolg',
    warning: 'Warnung',
    info: 'Info',
    danger: 'Gefahr',
    unknown: 'Unbekannt',
    notAvailable: 'k. A.',
    never: 'Nie',
    today: 'Heute',
    yesterday: 'Gestern',
    tomorrow: 'Morgen',
    now: 'Jetzt',
    ago: 'her',
    justNow: 'gerade eben',
    minutesAgo: 'vor {{count}} Min.',
    hoursAgo: 'vor {{count}} Std.',
    daysAgo: 'vor {{count}} T.',
    monthsAgo: 'vor {{count}} Mon.',
    id: 'ID',
    version: 'Version',
    language: 'Sprache',
    theme: 'Design',
    darkMode: 'Dunkelmodus',
    lightMode: 'Hellmodus',
    failedToLoad: 'Daten konnten nicht geladen werden',
    failedToSave: 'Speichern fehlgeschlagen',
    failedToDelete: 'Löschen fehlgeschlagen',
    failedToUpdate: 'Aktualisierung fehlgeschlagen',
    confirmDelete: 'Sind Sie sicher, dass Sie dies löschen möchten?',
    confirmAction: 'Sind Sie sicher?',
    unsavedChanges: 'Sie haben nicht gespeicherte Änderungen. Sind Sie sicher, dass Sie die Seite verlassen möchten?',
    pageNotFound: '404 – Seite nicht gefunden',
    pageNotFoundDesc: 'Die gesuchte Seite existiert nicht.',
    backToDashboard: 'Zurück zum Dashboard',
    characters: 'Zeichen',
    maxCharacters: 'Maximal {{max}} Zeichen',
    remaining: '{{count}} verbleibend',
    selected: '{{count}} ausgewählt',
    of_total: '{{count}} von {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Kopfzeile, Seitenleiste, Menüs
  // ============================================================
  nav: {
    dashboard: 'Dashboard',
    requests: 'Anfragen',
    transports: 'Transporte',
    missions: 'Missionen',
    myPatients: 'Meine Patienten',
    myPatientsTreatment: 'Behandlung',
    myPatientsTransport: 'Transport',
    statistics: 'Statistiken',
    flow: 'Fluss',
    resources: 'Resources',
    exercise: 'Übung',
    administration: 'Verwaltung',
    map: 'Karte',
    info: 'Info',
    users: 'Benutzer',
    assets: 'Transportmittel',
    hubs: 'Hubs',
    treatmentFacilities: 'Behandlungseinrichtungen',
    patientImport: 'Patientenimport',
    assetTemplates: 'Transportmittelvorlagen',
    dayTemplates: 'Tagesvorlagen',
    announcementTicker: 'Laufband-Meldungen',
    exerciseStatistics: 'Übungsstatistiken',
    settings: 'Einstellungen',
    auditLog: 'Auditprotokoll',
    exerciseControl: 'Übungssteuerung',
    dataSync: 'Datensynchronisation',
    documentation: 'Dokumentation',
    support: 'Support',
    about: 'Über',
    assetContracts: 'Asset Contracts',
    notifications: 'Benachrichtigungen',
    schedules: 'Fahrpläne',
    capacityPlanning: 'Kapazitätsplanung',
    transportPlanning: 'Transportplanung',
    transportBooking: 'Transportbuchung',
    flowDiagram: 'Flussdiagramm',
    changePassword: 'Passwort ändern',
    startPoints: 'Startpunkte',
    hospital: 'Krankenhaus',
  },

  // ============================================================
  // AUTH — Anmeldung, Passwort, Sitzung
  // ============================================================
  auth: {
    login: 'Anmelden',
    logout: 'Abmelden',
    logoutNow: 'Jetzt abmelden',
    loggingIn: 'Anmeldung läuft...',
    loginFailed: 'Anmeldung fehlgeschlagen',
    email: 'E-Mail',
    password: 'Passwort',
    username: 'Benutzername',
    enterEmail: 'Geben Sie Ihre E-Mail-Adresse ein',
    enterPassword: 'Geben Sie Ihr Passwort ein',
    enterUsername: 'Geben Sie Ihren Benutzernamen ein',
    forgotPassword: 'Passwort vergessen?',
    forgotPasswordTitle: 'Passwort vergessen',
    forgotPasswordDesc: 'Geben Sie Ihren Benutzernamen und Ihre E-Mail-Adresse ein. Wenn beide übereinstimmen, werden die Administratoren benachrichtigt, um Ihr Passwort zurückzusetzen.',
    requestPasswordReset: 'Passwort-Zurücksetzung anfordern',
    sending: 'Wird gesendet...',
    backToLogin: 'Zurück zur Anmeldung',
    pleaseWait: 'Bitte warten Sie, bevor Sie es erneut versuchen.',
    requestFailed: 'Anfrage fehlgeschlagen',
    credentialsMatch: 'Wenn die Anmeldedaten übereinstimmen, wurden die Administratoren benachrichtigt.',
    forAccess: 'Für den Zugang wenden Sie sich bitte an Ihren Systemadministrator.',
    changePassword: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    passwordChanged: 'Passwort erfolgreich geändert',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Das Passwort muss mindestens 8 Zeichen lang sein',
    changingPassword: 'Wird geändert...',
    mustChangePassword: 'Sie müssen Ihr Passwort ändern, bevor Sie fortfahren können.',
    sessionExpiring: 'Sitzung läuft ab',
    sessionExpireText: 'Ihre Sitzung läuft in <strong>{{time}}</strong> ab. Bitte speichern Sie Ihre Arbeit und melden Sie sich erneut an, um fortzufahren.',
    dismiss: 'Schließen',
    switchNation: 'Nation wechseln',
    returnTo: 'Zurück zu {{nation}}',
    viewingAs: 'Sie betrachten als',
    loggedInAs: 'angemeldet als {{nation}}',
    trainingMode: 'NUR ZU ÜBUNGSZWECKEN',
    dedication: 'Erstellt mit Leidenschaft und Hingabe für den Beruf',
  },

  // ============================================================
  // ROLES — Benutzerrollen und Bezeichnungen
  // ============================================================
  roles: {
    admin: 'Systemadministrator',
    excon: 'Übungsleiter',
    eu: 'EU-Koordinator',
    planner: 'Planer',
    hub: 'Hub-Manager',
    nation: 'Nation',
    readOnly: 'Nur Lesen',
    systemAdmin: 'Systemadministrator',
    transportPlanner: 'Transportplaner',
    systemRoles: 'Systemrollen',
  },

  // ============================================================
  // STATUS — Status von Anfragen, Angeboten, Missionen
  // ============================================================
  status: {
    draft: 'Entwurf',
    underReview: 'In Prüfung',
    published: 'Veröffentlicht',
    underSelection: 'In Auswahl',
    accepted: 'Angenommen',
    planned: 'Geplant',
    inTransit: 'Im Transport',
    completed: 'Abgeschlossen',
    closed: 'Geschlossen',
    withdrawn: 'Zurückgezogen',
    pending: 'Ausstehend',
    rejected: 'Abgelehnt',
    cancelled: 'Storniert',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    review: 'Prüfung',
    selection: 'Auswahl',
    transit: 'Transport',
  },

  // ============================================================
  // CATEGORIES — Anfragekategorien
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personal',
    material: 'Material',
    equipment: 'Ausrüstung',
    other: 'Sonstiges',
    news: 'Nachrichten',
  },

  // ============================================================
  // URGENCY — Dringlichkeitsstufen
  // ============================================================
  urgency: {
    routine: 'Routine',
    priority: 'Priorität',
    urgent: 'Dringend',
    immediate: 'Sofort',
  },

  // ============================================================
  // ASSETS — Transportmitteltypen
  // ============================================================
  assetTypes: {
    train: 'Zug',
    ship: 'Schiff',
    aircraft: 'Flugzeug',
    bus: 'Bus',
    ambulance: 'Krankenwagen',
    drone: 'Drohne',
    helicopter: 'Hubschrauber',
    ferry: 'Fähre',
    other: 'Sonstiges',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Guten Morgen',
    goodAfternoon: 'Guten Tag',
    goodEvening: 'Guten Abend',
    lastLogin: 'Letzte Anmeldung',
    infrastructure: 'Infrastruktur',
    transportAssets: 'Transportmittel',
    treatmentFacilities: 'Behandlungseinrichtungen',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Anfragestatistiken',
    viewAllRequests: 'Alle Anfragen anzeigen',
    availableAssets: 'Verfügbare Transportmittel',
    seated: 'Sitzend',
    lying: 'Liegend',
    intensive: 'Intensivpflege',
    notifications: 'Benachrichtigungen',
    markAllRead: 'Alle als gelesen markieren',
    noNotifications: 'Noch keine Benachrichtigungen',
    notifiedWhenActivity: 'Sie werden benachrichtigt, wenn neue Aktivitäten auftreten',
    viewDetailsBtn: 'Details anzeigen',
    nationUsers: 'Nationale Benutzer',
    user: 'Benutzer',
    roles: 'Rollen',
    noUsersFound: 'Keine Benutzer gefunden',
    participatingNations: 'Teilnehmende Nationen',
    exerciseDisclaimer: 'Dieses System dient ausschließlich der Übung. Geben Sie ausschließlich simulierte Übungsdaten ein. Die Arbeitsabläufe sind an das Übungsszenario angepasst und können von realen Verfahren abweichen. Die IT-Sicherheits- und Datenschutzregeln gelten uneingeschränkt.',
    notConfigured: 'Nicht konfiguriert',
    requestCount: '{{count}} Anfrage(n)',
    clickToView: 'Klicken zum Anzeigen',
    systemAdministration: 'Systemverwaltung',
    exerciseControlTitle: 'Übungssteuerung',
    euCoordination: 'EU-Koordination',
    transportPlanningTitle: 'Transportplanung',
    hubManagement: 'Hub-Verwaltung',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Neue Anfrage',
    myDrafts: 'Meine Entwürfe',
    pendingReview: 'Ausstehende Prüfung',
    activeTransports: 'Aktive Transporte',
    myPatients: 'Meine Patienten',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Anfragen',
    newRequest: 'Neue Anfrage',
    createRequest: 'Anfrage erstellen',
    editRequest: 'Anfrage bearbeiten',
    requestDetail: 'Anfragedetail',
    requestId: 'Anfrage-ID',
    fromNation: 'Von Nation',
    toNation: 'An Nation',
    requestingNation: 'Anfragende Nation',
    receivingNation: 'Empfangende Nation',
    category: 'Kategorie',
    urgency: 'Dringlichkeit',
    status: 'Status',
    patients: 'Patienten',
    patientCount: 'Patientenanzahl',
    offers: 'Angebote',
    offerCount: 'Angebotsanzahl',
    created: 'Erstellt',
    updated: 'Aktualisiert',
    submittedBy: 'Eingereicht von',
    reviewedBy: 'Geprüft von',
    description: 'Beschreibung',
    medicalDetails: 'Medizinische Details',
    transportDetails: 'Transportdetails',
    additionalInfo: 'Zusätzliche Informationen',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Abfahrtsort',
    arrivalPoint: 'Ankunftsort',
    estimatedDeparture: 'Voraussichtliche Abfahrt',
    estimatedArrival: 'Voraussichtliche Ankunft',
    submitForReview: 'Zur Prüfung einreichen',
    publish: 'Veröffentlichen',
    startSelection: 'Auswahl starten',
    acceptOffer: 'Angebot annehmen',
    markInTransit: 'Als im Transport markieren',
    markCompleted: 'Als abgeschlossen markieren',
    closeRequest: 'Anfrage schließen',
    withdrawRequest: 'Anfrage zurückziehen',
    withdraw: 'Zurückziehen',
    revertToDraft: 'Zum Entwurf zurücksetzen',
    deleteRequest: 'Anfrage löschen',
    duplicateRequest: 'Anfrage duplizieren',
    createFollowUp: 'Konsolidierte Anfrage erstellen',
    followUpRequest: 'Konsolidierte Anfrage',
    parentRequest: 'Ursprüngliche Anfrage',
    childRequests: 'Konsolidierte Anfragen',
    noRequests: 'Keine Anfragen gefunden',
    noOffers: 'Noch keine Angebote',
    addPatient: 'Patient hinzufügen',
    removePatient: 'Patient entfernen',
    patientDetails: 'Patientendetails',
    contactPerson: 'Kontaktperson',
    contactPhone: 'Kontakttelefon',
    contactEmail: 'Kontakt-E-Mail',
    specialRequirements: 'Besondere Anforderungen',
    medicalEquipment: 'Medizinische Ausrüstung',
    accompaniment: 'Begleitung',
    timeline: 'Zeitverlauf',
    history: 'Verlauf',
    addComment: 'Kommentar hinzufügen',
    writeComment: 'Kommentar schreiben...',
    postComment: 'Kommentar veröffentlichen',
    posting: 'Wird veröffentlicht...',
    noComments: 'Noch keine Kommentare',
    coverageBar: 'Abdeckung',
    covered: 'abgedeckt',
    uncovered: 'nicht abgedeckt',
    filterByStatus: 'Nach Status filtern',
    filterByCategory: 'Nach Kategorie filtern',
    filterByNation: 'Nach Nation filtern',
    searchRequests: 'Anfragen suchen...',
    confirmWithdraw: 'Sind Sie sicher, dass Sie diese Anfrage zurückziehen möchten?',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Anfrage löschen möchten?',
    confirmPublish: 'Sind Sie sicher, dass Sie diese Anfrage veröffentlichen möchten? Sie wird für alle Nationen sichtbar sein.',
    confirmStartSelection: 'Sind Sie sicher, dass Sie die Auswahl starten möchten? Nationen können dann Angebote abgeben.',
    warningStartSelection: 'Das Starten der Auswahl macht diese Anfrage für alle teilnehmenden Nationen sichtbar. Sie können Angebote für die Patienten dieser Anfrage einreichen. Diese Aktion kann nicht rückgängig gemacht werden.',
    warningMakeOffer: 'Mit der Einreichung dieses Angebots verpflichten Sie Ihre Nation, die vorgeschlagene Unterstützung zu leisten. Diese Aktion wird die anfragende Nation und die Übungsleitung benachrichtigen.',
    saveDraft: 'Entwurf speichern',
    saving: 'Wird gespeichert...',
    saveAndSubmit: 'Speichern und einreichen',
    step: 'Schritt {{number}}',
    generalInfo: 'Allgemeine Informationen',
    patientInfo: 'Patienteninformationen',
    logisticsInfo: 'Logistikinformationen',
    reviewSubmit: 'Überprüfung und Einreichung',
    requestTitle: 'Anfragetitel',
    requestDescription: 'Anfragebeschreibung',
    numberOfPatients: 'Anzahl der Patienten',
    typeOfAssistance: 'Art der Unterstützung',
    medicalTreatment: 'Medizinische Behandlung',
    transportAssistance: 'Transportunterstützung',
    both: 'Beides',
    treatmentOnly: 'Nur Behandlung',
    transportOnly: 'Nur Transport',
    missingTransport: 'Fehlender Transport',
    noOffersReceived: 'Keine Angebote',
    validationErrors: 'Bitte beheben Sie die folgenden Fehler:',
    fieldRequired: 'Dieses Feld ist erforderlich',
    selectExitHub: 'Ausgangshub auswählen',
    createExitHub: 'Ausgangshub erstellen',
    backToRequests: 'Zurück zu Anfragen',
    noRequestsFound: 'Keine Anfragen gefunden',
    createFirstRequest: 'Erstellen Sie Ihre erste Anfrage, um zu beginnen',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Angebote',
    createOffer: 'Angebot erstellen',
    makeOffer: 'Angebot abgeben',
    manageOffers: 'Angebote verwalten',
    offerDetail: 'Angebotsdetail',
    offerId: 'Angebots-ID',
    offeringNation: 'Anbietende Nation',
    offerType: 'Angebotstyp',
    treatment: 'Behandlung',
    transport: 'Transport',
    combined: 'Kombiniert',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Behandlungsangebot',
    transportOffer: 'Transportangebot',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Patienten auswählen',
    selectedPatients: 'Ausgewählte Patienten',
    patientSelection: 'Patientenauswahl',
    offerConfiguration: 'Angebotskonfiguration',
    reviewOffer: 'Angebot überprüfen',
    submitOffer: 'Angebot einreichen',
    submitting: 'Wird eingereicht...',
    acceptOffer: 'Angebot annehmen',
    rejectOffer: 'Angebot ablehnen',
    withdrawOffer: 'Angebot zurückziehen',
    noOffers: 'Keine Angebote verfügbar',
    noOffer: 'Kein Angebot',
    offerStatus: 'Angebotsstatus',
    offerDate: 'Angebotsdatum',
    transportAsset: 'Transportmittel',
    departureDate: 'Abfahrtsdatum',
    arrivalDate: 'Ankunftsdatum',
    treatmentFacility: 'Behandlungseinrichtung',
    capacity: 'Kapazität',
    availableCapacity: 'Verfügbare Kapazität',
    totalCapacity: 'Gesamtkapazität',
    selectAsset: 'Transportmittel auswählen',
    selectFacility: 'Einrichtung auswählen',
    offerNotes: 'Angebotsnotizen',
    confirmAccept: 'Sind Sie sicher, dass Sie dieses Angebot annehmen möchten?',
    confirmReject: 'Sind Sie sicher, dass Sie dieses Angebot ablehnen möchten?',
    extendTransport: 'Transport verlängern',
    transportExtension: 'Transportverlängerung',
    comparisonView: 'Vergleichsansicht',
    shortlist: 'Vorauswahl',
    hideLockedPatients: 'Bereits ausgewählte Patienten aus anderen Offers ausblenden',
    addToShortlist: 'Zur Vorauswahl hinzufügen',
    removeFromShortlist: 'Aus Vorauswahl entfernen',
    leaveConfirmTitle: 'Seite verlassen?',
    leaveConfirmMessage: 'Sie haben nicht gespeicherte Änderungen. Sind Sie sicher, dass Sie die Seite verlassen möchten?',
    stayOnPage: 'Auf der Seite bleiben',
    leavePage: 'Seite verlassen',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporte',
    missionDetail: 'Transportdetail',
    missionId: 'Transport-ID',
    missionStatus: 'Transportstatus',
    createMission: 'Transport erstellen',
    overview: 'Übersicht',
    patientsTab: 'Patienten',
    transportsTab: 'Transportabschnitte',
    treatmentTab: 'Behandlung',
    reviewTab: 'Überprüfung',
    departure: 'Abfahrt',
    arrival: 'Ankunft',
    origin: 'Herkunft',
    destination: 'Ziel',
    stops: 'Haltestellen',
    addStop: 'Haltestelle hinzufügen',
    removeStop: 'Haltestelle entfernen',
    stopName: 'Name der Haltestelle',
    stopType: 'Haltestellentyp',
    estimatedTime: 'Geschätzte Zeit',
    actualTime: 'Tatsächliche Zeit',
    asset: 'Transportmittel',
    driver: 'Fahrer',
    crew: 'Besatzung',
    noMissions: 'Keine Transporte gefunden',
    completeMission: 'Transport abschließen',
    cancelMission: 'Transport stornieren',
    startTransport: 'Transport starten',
    missionChain: 'Transportkette',
    linkedMissions: 'Verknüpfte Transporte',
    handover: 'Übergabe',
    handoverPoint: 'Übergabepunkt',
    pickupPoint: 'Abholpunkt',
    dropoffPoint: 'Absetzpunkt',
    searchTransports: 'Transporte suchen...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patienten',
    myPatients: 'Meine Patienten',
    patientId: 'Patienten-ID',
    firstName: 'Vorname',
    lastName: 'Nachname',
    dateOfBirth: 'Geburtsdatum',
    age: 'Alter',
    gender: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Sonstiges',
    nationality: 'Staatsangehörigkeit',
    diagnosis: 'Diagnose',
    condition: 'Zustand',
    dependency: 'Dependency',
    stable: 'Stabil',
    critical: 'Kritisch',
    serious: 'Ernst',
    treatmentNeeded: 'Behandlung erforderlich',
    allergies: 'Allergien',
    medications: 'Medikamente',
    bloodType: 'Blutgruppe',
    weight: 'Gewicht (kg)',
    infectious: 'Infektiös',
    mentalHealth: 'Psychische Gesundheit',
    mobility: 'Mobilität',
    ambulatory: 'Gehfähig',
    wheelchair: 'Rollstuhl',
    stretcher: 'Trage',
    intensive: 'Intensivpflege',
    oxygenRequired: 'Sauerstoff erforderlich',
    ventilator: 'Beatmungsgerät',
    medicalEscort: 'Medizinische Begleitung',
    noPatients: 'Keine Patienten gefunden',
    patientDetails: 'Patientendetails',
    medicalHistory: 'Krankengeschichte',
    travelDocuments: 'Reisedokumente',
    passport: 'Reisepass',
    pseudonymizedId: 'Pseudonymisierte ID',
    sensitiveData: 'Sensible Daten',
    journey: 'Patientenweg',
    assignedTo: 'Zugewiesen an',
    currentLocation: 'Aktueller Standort',
    importPatients: 'Patienten importieren',
    exportPatients: 'Patienten exportieren',
    seated: 'Sitzend',
    lying: 'Liegend',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Benutzer',
    createUser: 'Benutzer erstellen',
    editUser: 'Benutzer bearbeiten',
    deleteUser: 'Benutzer löschen',
    username: 'Benutzername',
    displayName: 'Anzeigename',
    email: 'E-Mail',
    password: 'Passwort',
    role: 'Rolle',
    roles: 'Rollen',
    nation: 'Nation',
    active: 'Aktiv',
    lastLogin: 'Letzte Anmeldung',
    createdAt: 'Erstellt',
    isNation: 'Nation',
    isEU: 'EU',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planer',
    isHub: 'Hub',
    isReadOnly: 'Nur Lesen',
    noUsers: 'Keine Benutzer gefunden',
    confirmDelete: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
    resetPassword: 'Passwort zurücksetzen',
    generatePassword: 'Passwort generieren',
    searchUsers: 'Benutzer suchen...',
    userCreated: 'Benutzer erfolgreich erstellt',
    userUpdated: 'Benutzer erfolgreich aktualisiert',
    userDeleted: 'Benutzer erfolgreich gelöscht',
    selectNation: 'Nation auswählen',
    mustChangePassword: 'Muss das Passwort bei der nächsten Anmeldung ändern',
    flagImage: 'Flaggenbild',
    exportUsers: 'Benutzer exportieren',
    importUsers: 'Benutzer importieren',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Transportmittel',
    createAsset: 'Transportmittel erstellen',
    editAsset: 'Transportmittel bearbeiten',
    deleteAsset: 'Transportmittel löschen',
    assetName: 'Name des Transportmittels',
    assetType: 'Transportmitteltyp',
    capacitySeated: 'Kapazität (sitzend)',
    capacityLying: 'Kapazität (liegend)',
    capacityIntensive: 'Kapazität (Intensivpflege)',
    owner: 'Eigentümer',
    operator: 'Betreiber',
    baseLocation: 'Basisstandort',
    range: 'Reichweite',
    speed: 'Geschwindigkeit',
    noAssets: 'Keine Transportmittel gefunden',
    confirmDelete: 'Sind Sie sicher, dass Sie dieses Transportmittel löschen möchten?',
    searchAssets: 'Transportmittel suchen...',
    assetCreated: 'Transportmittel erfolgreich erstellt',
    assetUpdated: 'Transportmittel erfolgreich aktualisiert',
    assetDeleted: 'Transportmittel erfolgreich gelöscht',
    exportAssets: 'Transportmittel exportieren',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubs',
    startPoints: 'Startpunkte',
    createHub: 'Hub erstellen',
    editHub: 'Hub bearbeiten',
    deleteHub: 'Hub löschen',
    hubName: 'Hub-Name',
    hubType: 'Hub-Typ',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Eingangshub',
    airport: 'Flughafen',
    seaport: 'Seehafen',
    railStation: 'Bahnhof',
    roadPoint: 'Straßenpunkt',
    ucpmClassification: 'UCPM-Klassifizierung',
    icaoCode: 'ICAO-Code',
    iataCode: 'IATA-Code',
    noHubs: 'Keine Hubs gefunden',
    confirmDelete: 'Sind Sie sicher, dass Sie diesen Hub löschen möchten?',
    searchHubs: 'Hubs suchen...',
    nationAssignment: 'Nationenzuordnung',
    assignNations: 'Nationen zuordnen',
    availableNations: 'Verfügbare Nationen',
    assignedNations: 'Zugewiesene Nationen',
    originNationHint: 'Die Nation, in der sich der Hub befindet ({{nation}}), hat automatisch Zugriff.',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Behandlungseinrichtungen',
    createFacility: 'Einrichtung erstellen',
    editFacility: 'Einrichtung bearbeiten',
    deleteFacility: 'Einrichtung löschen',
    facilityName: 'Name der Einrichtung',
    facilityType: 'Einrichtungstyp',
    hospitalName: 'Krankenhausname',
    bedCapacity: 'Bettenkapazität',
    specialties: 'Fachrichtungen',
    availableBeds: 'Verfügbare Betten',
    totalBeds: 'Gesamtbetten',
    contactPerson: 'Kontaktperson',
    noFacilities: 'Keine Behandlungseinrichtungen gefunden',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Einrichtung löschen möchten?',
    searchFacilities: 'Einrichtungen suchen...',
    hubNationAssignment: 'Hub-Nationenzuordnung',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Fahrpläne',
    createSchedule: 'Fahrplan erstellen',
    editSchedule: 'Fahrplan bearbeiten',
    deleteSchedule: 'Fahrplan löschen',
    scheduleName: 'Fahrplanname',
    scheduleType: 'Fahrplantyp',
    recurring: 'Wiederkehrend',
    oneTime: 'Einmalig',
    frequency: 'Häufigkeit',
    daily: 'Täglich',
    weekly: 'Wöchentlich',
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    departureTime: 'Abfahrtszeit',
    arrivalTime: 'Ankunftszeit',
    stops: 'Haltestellen',
    addStop: 'Haltestelle hinzufügen',
    noSchedules: 'Keine Fahrpläne gefunden',
    bookings: 'Buchungen',
    timeline: 'Zeitverlauf',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Benachrichtigungen',
    markAllRead: 'Alle als gelesen markieren',
    markAsRead: 'Als gelesen markieren',
    markAsUnread: 'Als ungelesen markieren',
    noNotifications: 'Keine Benachrichtigungen',
    viewAll: 'Alle Benachrichtigungen anzeigen',
    settings: 'Benachrichtigungseinstellungen',
    emailNotifications: 'E-Mail-Benachrichtigungen',
    inAppNotifications: 'In-App-Benachrichtigungen',
    notifyOn: 'Benachrichtigen bei',
    requestCreated: 'Neue Anfrage',
    requestPublished: 'Anfrage veröffentlicht',
    requestClosed: 'Anfrage geschlossen',
    requestCompleted: 'Anfrage abgeschlossen',
    commentAdded: 'Neuer Kommentar',
    offerReceived: 'Angebot erhalten',
    offerAccepted: 'Angebot angenommen',
    statusChanged: 'Status geändert',
    selectionStarted: 'Auswahl gestartet',
    missionCreated: 'Transport erstellt',
    missionStatusUpdated: 'Transport aktualisiert',
    transportPartnerNamed: 'Transportpartner',
    transportExtensionReceived: 'Transportverlängerung',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Einstellungen',
    general: 'Allgemein',
    system: 'System',
    email: 'E-Mail',
    sync: 'Synchronisation',
    security: 'Sicherheit',
    appearance: 'Darstellung',
    systemName: 'Systemname',
    systemEmail: 'System-E-Mail',
    maintenanceMode: 'Wartungsmodus',
    readOnlyMode: 'Nur-Lesen-Modus',
    emailEnabled: 'E-Mail aktiviert',
    smtpHost: 'SMTP-Host',
    smtpPort: 'SMTP-Port',
    smtpUser: 'SMTP-Benutzer',
    smtpPassword: 'SMTP-Passwort',
    senderEmail: 'Absender-E-Mail',
    senderName: 'Absendername',
    testEmail: 'Test-E-Mail senden',
    syncEnabled: 'Synchronisation aktiviert',
    syncUrl: 'Synchronisations-URL',
    syncApiKey: 'Synchronisations-API-Schlüssel',
    settingsSaved: 'Einstellungen erfolgreich gespeichert',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Helpdesk-Titel',
    helpdeskEmail: 'Helpdesk-E-Mail',
    helpdeskPhone: 'Helpdesk-Telefon',
    helpdeskInfo: 'Helpdesk-Informationen',
    realLifeSupport: 'Unterstützung im Echtfall',
    trainingMode: 'Übungsmodus',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Auditprotokoll',
    action: 'Aktion',
    user: 'Benutzer',
    target: 'Ziel',
    details: 'Details',
    timestamp: 'Zeitstempel',
    ipAddress: 'IP-Adresse',
    noLogs: 'Keine Auditprotokolle gefunden',
    searchLogs: 'Protokolle suchen...',
    filterByAction: 'Nach Aktion filtern',
    filterByUser: 'Nach Benutzer filtern',
    exportLogs: 'Protokolle exportieren',
    exportCsv: 'CSV exportieren',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Übungssteuerung',
    currentDay: 'Aktueller Tag',
    exerciseDay: 'Übungstag',
    nextDay: 'Nächster Tag',
    previousDay: 'Vorheriger Tag',
    resetExercise: 'Übung zurücksetzen',
    startExercise: 'Übung starten',
    endExercise: 'Übung beenden',
    dayReset: 'Tagesrücksetzung',
    confirmReset: 'Sind Sie sicher, dass Sie den Übungstag zurücksetzen möchten? Dadurch werden alle Daten des aktuellen Tages gelöscht.',
    resetInProgress: 'Zurücksetzung läuft...',
    maintenanceMode: 'Wartungsmodus',
    enableMaintenance: 'Wartung aktivieren',
    disableMaintenance: 'Wartung deaktivieren',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Datensynchronisation',
    syncStatus: 'Synchronisationsstatus',
    lastSync: 'Letzte Synchronisation',
    pendingItems: 'Ausstehende Einträge',
    syncNow: 'Jetzt synchronisieren',
    syncing: 'Synchronisierung läuft...',
    syncSuccess: 'Synchronisation erfolgreich abgeschlossen',
    syncFailed: 'Synchronisation fehlgeschlagen',
    outbox: 'Ausgang',
    inbox: 'Eingang',
    configuration: 'Konfiguration',
    targetUrl: 'Ziel-URL',
    apiKey: 'API-Schlüssel',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Karte',
    layers: 'Ebenen',
    requests: 'Anfragen',
    hubs: 'Hubs',
    facilities: 'Einrichtungen',
    routes: 'Routen',
    showAll: 'Alle anzeigen',
    hideAll: 'Alle ausblenden',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    resetView: 'Ansicht zurücksetzen',
    satellite: 'Satellit',
    terrain: 'Gelände',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Kartenkacheln werden lokal bereitgestellt',
    tilesOnline: 'Kartenkacheln werden von Online-Servern geladen',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistiken',
    overview: 'Übersicht',
    requestsByStatus: 'Anfragen nach Status',
    requestsByCategory: 'Anfragen nach Kategorie',
    requestsByNation: 'Anfragen nach Nation',
    offersByStatus: 'Angebote nach Status',
    patientsByCondition: 'Patienten nach Zustand',
    transportsByStatus: 'Transporte nach Status',
    timeline: 'Zeitverlauf',
    totalRequests: 'Anfragen gesamt',
    totalOffers: 'Angebote gesamt',
    totalPatients: 'Patienten gesamt',
    totalTransports: 'Transporte gesamt',
    averageResponseTime: 'Durchschnittliche Antwortzeit',
    completionRate: 'Abschlussrate',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Übungsstatistiken',
    overview: 'Übersicht',
    byCategory: 'Nach Kategorie',
    byNation: 'Nach Nation',
    byDay: 'Nach Tag',
    totalPatientsMoved: 'Insgesamt verlegte Patienten',
    totalRequestsProcessed: 'Insgesamt bearbeitete Anfragen',
    averageProcessingTime: 'Durchschnittliche Bearbeitungszeit',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Flussdiagramm',
    sankey: 'Sankey',
    nodeGraph: 'Knotengraph',
    refresh: 'Aktualisieren',
    noData: 'Keine Flussdaten verfügbar',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Über',
    version: 'Version',
    systemInfo: 'Systeminformationen',
    buildDate: 'Build-Datum',
    environment: 'Umgebung',
    description: 'ARCOS — Erweitertes Anfragekommunikationssystem',
    subtitle: 'Opferhilfe & Medizinische Operationen',
    whatIsArcos: 'Was ist ARCOS? – Erklärung für Übungsteilnehmer',
    arcosDesc1: 'ARCOS ist ein digitales Werkzeug, das in dieser Übung eingesetzt wird, um internationale Kommunikation, Anfragen und Koordinierungsprozesse zwischen den teilnehmenden Akteuren zu unterstützen und zu strukturieren. Es ist wichtig zu verstehen, dass ARCOS kein operationelles System ist und reale Plattformen wie CECIS oder EWRS nicht ersetzt.',
    arcosDesc2: 'Stattdessen bietet ARCOS eine vereinfachte, übungsorientierte Darstellung der grundlegenden Prinzipien dieser Systeme. Sein Zweck ist es, den Teilnehmern während der Übung einen gemeinsamen, konsistenten Rahmen zu bieten, ohne Zugang zu geschützten oder operationellen Umgebungen zu benötigen.',
    arcosUsedFor: 'Während der Übung wird ARCOS verwendet, um typische Prozesse darzustellen wie:',
    arcosUsedForItem1: 'Einreichung und Verwaltung von Hilfeersuchen (z.B. medizinische Unterstützung, Personal oder Material),',
    arcosUsedForItem2: 'Koordinierung und Beantwortung von Unterstützungsangeboten anderer Nationen oder Organisationen,',
    arcosUsedForItem3: 'Verfolgung des Status und Fortschritts von Anfragen,',
    arcosUsedForItem4: 'und vereinfachte Darstellung von Transport- oder Evakuierungsabläufen.',
    arcosDesc3: 'Die Arbeitsabläufe in ARCOS sind absichtlich vereinfacht und an die spezifischen Ausbildungsziele der Übung angepasst. Darüber hinaus enthält ARCOS bestimmte Funktionen, die in realen Systemen nicht existieren, aber für Schulungs- und Diskussionszwecke nützlich sind.',
    arcosDesc4: 'Das Ziel von ARCOS ist nicht, ein perfektes oder vollständiges reales System zu simulieren. Es zielt vielmehr darauf ab, ein klares, strukturiertes und gemeinsames Verständnis dafür zu vermitteln, wie multinationale Koordinierungsprozesse grundsätzlich funktionieren.',
    arcosDesc5: 'Wenn bestimmte Elemente oder Abläufe in ARCOS von realen Verfahren abweichen, die Ihnen bekannt sind, ist dies zu erwarten. ARCOS spiegelt die Logik der Übung wider, nicht die volle operationelle Komplexität von Systemen wie CECIS oder EWRS.',
    facilitatedBy: 'Unterstützt durch MMCC-E',
    dhcInitiative: 'Der Digital Health Corner (DHC) ist eine gemeinsame Initiative von:',
    dhcAuthor1: 'Sven Giegerich — Deutsche Bundeswehr',
    dhcAuthor2: 'Mohamad Haji — Belgische Verteidigung',
    dhcConviction: 'Entstanden aus der Überzeugung, dass Innovation dort gedeiht, wo Leidenschaft auf Pragmatismus trifft.',
    dhcInspired: 'Inspiriert durch den ersten Funken des MMCC-E haben wir uns vorgenommen, einfache aber effektive Lösungen auf Basis bestehender Systeme zu schaffen – Werkzeuge, die Planübungen (TTX) effizienter, realistischer und zugänglicher machen.',
    dhcLove: 'Wir tun dies, weil wir unsere Arbeit lieben und glauben, dass digitale Ideen die Zusammenarbeit im militärischen Gesundheitswesen neu gestalten können.',
    dhcOpen: 'Der DHC ist eine offene Plattform: frei von Hierarchien, offen für Ideen, angetrieben von Neugier und Zusammenarbeit. Wir suchen Gleichgesinnte, die unsere Begeisterung teilen – Menschen, die gemeinsam denken, bauen und schaffen wollen.',
    dhcClosing: 'Digital Health Corner – wo Neugier auf Zusammenarbeit trifft.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentation',
    gettingStarted: 'Erste Schritte',
    userGuide: 'Benutzerhandbuch',
    faq: 'FAQ',
    troubleshooting: 'Fehlerbehebung',
    apiReference: 'API-Referenz',
    downloadTemplate: 'Vorlage herunterladen',
    overviewDesc: 'CAMO26 (Zivil-Militärische Medizinische Hilfsoperationen 2026) ist ein Simulationssystem für den CECIS-Workflow. Als <strong>Nation-Benutzer</strong> können Sie Hilfeersuchen erstellen und verwalten, mit anderen Nationen kommunizieren und medizinische Unterstützungsoperationen koordinieren.',
    dashboardDesc: 'Das Dashboard bietet einen Überblick über alle Anfragen im System und zeigt Statistiken nach Status. Klicken Sie auf eine Statistikkarte, um gefilterte Anfragen anzuzeigen.',
    navigationInfo: 'Navigationsinformationen',
    navDashboard: 'Dashboard - Systemübersicht und Statistiken',
    navRequests: 'Anfragen - Alle Anfragen in Listenformat anzeigen',
    navNewRequest: 'Neue Anfrage - Eine neue Hilfeanfrage erstellen',
    navNotifications: 'Benachrichtigungen - Das Glockensymbol in der Kopfzeile zeigt neue Aktivitäten',
    step1Title: 'Schritt 1: Grundinformationen',
    step1Item1: 'Klicken Sie auf <strong>„Neue Anfrage"</strong> im Navigationsmenü',
    step1Item2: 'Geben Sie einen beschreibenden <strong>Titel</strong> für Ihre Anfrage ein',
    step1Item3: 'Geben Sie eine detaillierte <strong>Beschreibung</strong> der benötigten Hilfe an',
    step1Item4: 'Wählen Sie die <strong>Kategorie</strong>:',
    catMedevac: 'MEDEVAC - Medizinische Evakuierung von Patienten',
    catPersonnel: 'PERSONAL - Anfrage nach medizinischem Personal',
    catEquipment: 'AUSRÜSTUNG - Anfrage nach medizinischer Ausrüstung oder Verbrauchsmaterial',
    catOther: 'SONSTIGES - Andere Arten von Hilfe',
    step1Item5: 'Setzen Sie die <strong>Dringlichkeitsstufe</strong> (NIEDRIG, NORMAL, HOCH)',
    step1Item6: 'Setzen Sie optional eine <strong>„Antwort bis"</strong>-Frist',
    step2Title: 'Schritt 2: Patientendaten hinzufügen (nur MEDEVAC)',
    step2Desc: 'Für MEDEVAC-Anfragen können Sie Patienteninformationen hinzufügen:',
    step2ManualEntry: 'Manuelle Eingabe - Füllen Sie das Patientenformular für jede Person aus',
    step2ExcelUpload: 'Excel-Upload - Laden Sie eine vorausgefüllte Excel-Datei mit Patientendaten hoch',
    step2ExcelItem1: 'Laden Sie die Vorlage von der Anfrageseite herunter',
    step2ExcelItem2: 'Füllen Sie die Patientendetails gemäß dem Format aus',
    step2ExcelItem3: 'Laden Sie die ausgefüllte Datei hoch',
    step3Title: 'Schritt 3: Zur Prüfung einreichen',
    step3Desc: 'Sobald Ihre Anfrage vollständig ist, reichen Sie sie zur EU-Prüfung ein. Die Anfrage wechselt zum Status <strong>„IN_PRÜFUNG"</strong> und die EU-Koordinatoren werden benachrichtigt.',
    requestWorkflow: 'Anfrage-Workflow',
    workflowDraft: 'Ersterstellung - nur für Sie sichtbar',
    workflowReview: 'Zur EU-Genehmigung eingereicht',
    workflowPublished: 'Für alle Nationen sichtbar - kann Angebote erhalten',
    workflowTransit: 'Angebot akzeptiert - Hilfe in Bearbeitung',
    workflowCompleted: 'Hilfe erfolgreich geliefert',
    workflowNote: '<strong>Hinweis:</strong> EU-Koordinatoren können Anfragen auch auf den Status <strong>GESCHLOSSEN</strong> setzen, wenn nötig.',
    viewingRequests: 'Anfragen anzeigen und verwalten',
    ownRequests: 'Ihre eigenen Anfragen',
    ownRequestItem1: 'Alle Ihre Anfragen unabhängig vom Status anzeigen',
    ownRequestItem2: 'ENTWURF-Anfragen vor der Einreichung bearbeiten',
    ownRequestItem3: 'Statusänderungen und Updates verfolgen',
    ownRequestItem4: 'Angebote von anderen Nationen akzeptieren',
    ownRequestItem5: 'Anfragen als ABGESCHLOSSEN markieren, wenn die Hilfe geliefert wurde',
    otherRequests: 'Anfragen anderer Nationen',
    otherRequestItem1: 'Alle VERÖFFENTLICHTEN Anfragen anderer Nationen anzeigen',
    otherRequestItem2: 'Kommentare hinzufügen, um Details zu besprechen',
    otherRequestItem3: 'Angebote zur Hilfeleistung einreichen',
    otherRequestItem4: 'Verfolgen, welche Anfragen erfüllt wurden',
    fullOffer: 'Vollständiges Angebot',
    fullOfferDesc: 'Sie können die gesamte Anfrage erfüllen:',
    fullOfferItem1: 'Öffnen Sie eine VERÖFFENTLICHTE Anfrage einer anderen Nation',
    fullOfferItem2: 'Klicken Sie auf <strong>„Angebot machen"</strong>',
    fullOfferItem3: 'Beschreiben Sie, was Sie bereitstellen können',
    fullOfferItem4: 'Reichen Sie das Angebot ein',
    partialOffer: 'Teilangebot (nur MEDEVAC)',
    partialOfferDesc: 'Für MEDEVAC-Anfragen können Sie anbieten, einige Patienten zu übernehmen:',
    partialOfferItem1: 'Wählen Sie bestimmte Patienten aus der Liste',
    partialOfferItem2: 'Beschreiben Sie Ihre Kapazität und Fähigkeiten',
    partialOfferItem3: 'Reichen Sie das Teilangebot ein',
    offerImportant: '<strong>Wichtig:</strong> Die anfragende Nation muss Ihr Angebot akzeptieren, bevor es aktiv wird.',
    commentsUsage: 'Verwenden Sie Kommentare bei VERÖFFENTLICHTEN Anfragen für:',
    commentItem1: 'Fragen zu Anforderungen stellen',
    commentItem2: 'Details klären, bevor Sie ein Angebot machen',
    commentItem3: 'Logistik und Zeitplanung koordinieren',
    commentItem4: 'Updates während der Ausführung teilen',
    notifDesc: 'Sie erhalten Benachrichtigungen für:',
    notifItem1: 'Neue veröffentlichte Anfragen anderer Nationen',
    notifItem2: 'Kommentare zu Ihren Anfragen oder Anfragen, mit denen Sie interagiert haben',
    notifItem3: 'Eingegangene Angebote zu Ihren Anfragen',
    notifItem4: 'Statusänderungen Ihrer Anfragen',
    notifItem5: 'Angebotsannahme/-ablehnung',
    notifBell: 'Überprüfen Sie das Glockensymbol in der Kopfzeile, um Benachrichtigungen anzuzeigen. Das Badge zeigt die Anzahl ungelesener.',
    requestIdFormat: 'Anfrage-ID-Format',
    requestIdDesc: 'Jede Anfrage erhält eine eindeutige ID im Format: <code>XXX-JJJJ-NNN</code>',
    requestIdPart1: '<strong>XXX</strong> - Der ISO 3166-1 Alpha-3-Code Ihrer Nation (z.B. DEU, FRA, GBR)',
    requestIdPart2: '<strong>JJJJ</strong> - Aktuelles Jahr',
    requestIdPart3: '<strong>NNN</strong> - Laufende Nummer für Ihre Nation in diesem Jahr',
    requestIdExample: '<strong>Beispiel:</strong> <code>DEU-2025-001</code> ist Deutschlands erste Anfrage im Jahr 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Effektive Anfragen erstellen',
    effectiveItem1: 'Verwenden Sie klare, beschreibende Titel',
    effectiveItem2: 'Geben Sie vollständige Details in der Beschreibung an',
    effectiveItem3: 'Setzen Sie realistische Dringlichkeitsstufen',
    effectiveItem4: 'Für MEDEVAC: Genaue Patienteninformationen angeben',
    effectiveItem5: 'Angemessene Fristen für Antworten setzen',
    collaboration: 'Zusammenarbeit',
    collabItem1: 'Reagieren Sie zeitnah auf Kommentare zu Ihren Anfragen',
    collabItem2: 'Prüfen Sie Angebote sorgfältig vor der Annahme',
    collabItem3: 'Aktualisieren Sie den Anfragestatus bei Änderungen',
    collabItem4: 'Markieren Sie Anfragen als ABGESCHLOSSEN, wenn die Hilfe geliefert wurde',
    collabItem5: 'Kommunizieren Sie Änderungen oder Probleme über Kommentare',
    systemEtiquette: 'Systemregeln',
    etiquetteItem1: 'Reichen Sie Anfragen nur ein, wenn sie vollständig sind',
    etiquetteItem2: 'Erstellen Sie keine doppelten Anfragen',
    etiquetteItem3: 'Verwenden Sie angemessene Dringlichkeitsstufen - HOCH nur für echte Notfälle',
    etiquetteItem4: 'Schließen oder vervollständigen Sie Anfragen, die nicht mehr benötigt werden',
    supportDesc: 'Bei technischen Problemen oder Fragen zur Systemnutzung kontaktieren Sie bitte:',
    supportContact: 'Multinationales Medizinisches Koordinierungszentrum - Europa (MMCC-E)',
    importantNotice: 'Wichtiger Hinweis',
    importantNoticeText1: 'Dies ist ein Simulationssystem nur für Schulungs- und Übungszwecke.',
    importantNoticeText2: 'CAMO26 simuliert den grundlegenden CECIS-Workflow. Viele CECIS-Funktionen sind hier nicht dargestellt. Dieses System ist für Planübungen (TTX) konzipiert und sollte nicht für tatsächliche Notfalleinsätze verwendet werden.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Patientenimport',
    uploadFile: 'Datei hochladen',
    selectFile: 'Datei auswählen',
    preview: 'Vorschau',
    importNow: 'Jetzt importieren',
    importing: 'Import läuft...',
    importSuccess: '{{count}} Patient(en) erfolgreich importiert',
    importFailed: 'Import fehlgeschlagen',
    downloadTemplate: 'Vorlage herunterladen',
    dragDrop: 'Datei hierher ziehen oder klicken, um auszuwählen',
    supportedFormats: 'Unterstützte Formate: XLSX, XLS, CSV',
    rowsFound: '{{count}} Zeile(n) gefunden',
    validRows: '{{count}} gültige Zeile(n)',
    invalidRows: '{{count}} ungültige Zeile(n)',
    duplicateRows: '{{count}} doppelte Zeile(n)',
    previewData: 'Datenvorschau',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transportplanung',
    planRoute: 'Route planen',
    routeBuilder: 'Routenplaner',
    addWaypoint: 'Wegpunkt hinzufügen',
    removeWaypoint: 'Wegpunkt entfernen',
    estimatedDuration: 'Geschätzte Dauer',
    distance: 'Entfernung',
    selectVehicle: 'Fahrzeug auswählen',
    unsavedChanges: 'Es gibt ungespeicherte Änderungen an Ihren Transportplänen. Vor dem Verlassen speichern?',
  },

  transportBooking: {
    title: 'Transportbuchung',
    bookTransport: 'Transport buchen',
    availableSlots: 'Verfügbare Plätze',
    bookingConfirmed: 'Buchung bestätigt',
    cancelBooking: 'Buchung stornieren',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapazitätsplanung',
    totalCapacity: 'Gesamtkapazität',
    usedCapacity: 'Genutzte Kapazität',
    availableCapacity: 'Verfügbare Kapazität',
    utilizationRate: 'Auslastungsrate',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Transportmittelvorlagen',
    dayTemplates: 'Tagesvorlagen',
    createTemplate: 'Vorlage erstellen',
    editTemplate: 'Vorlage bearbeiten',
    deleteTemplate: 'Vorlage löschen',
    templateName: 'Vorlagenname',
    applyTemplate: 'Vorlage anwenden',
    noTemplates: 'Keine Vorlagen gefunden',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Vorlage löschen möchten?',
    confirmApply: 'Sind Sie sicher, dass Sie diese Vorlage anwenden möchten? Vorhandene Daten werden überschrieben.',
    exportTemplates: 'Vorlagen exportieren',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Laufband-Meldungen',
    createAnnouncement: 'Meldung erstellen',
    editAnnouncement: 'Meldung bearbeiten',
    deleteAnnouncement: 'Meldung löschen',
    message: 'Nachricht',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    active: 'Aktiv',
    noAnnouncements: 'Keine Meldungen',
    confirmDelete: 'Sind Sie sicher, dass Sie diese Meldung löschen möchten?',
  },

  // ============================================================
  // COMPONENTS — Zeichenketten der wiederverwendbaren Komponenten
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Suchen...',
      noResults: 'Keine Ergebnisse gefunden',
      showing: '{{from}} bis {{to}} von {{total}} angezeigt',
      rowsPerPage: 'Zeilen pro Seite',
      previousPage: 'Vorherige Seite',
      nextPage: 'Nächste Seite',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Bestätigen',
      cancel: 'Abbrechen',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Nicht gespeicherte Änderungen',
      message: 'Sie haben nicht gespeicherte Änderungen. Sind Sie sicher, dass Sie diese Seite verlassen möchten?',
      stay: 'Auf der Seite bleiben',
      leave: 'Seite verlassen',
    },
    // EmptyState
    emptyState: {
      noData: 'Keine Daten verfügbar',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Etwas ist schiefgelaufen',
      message: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie, die Seite zu aktualisieren.',
      retry: 'Erneut versuchen',
    },
    // ExportButton
    exportButton: {
      export: 'Exportieren',
      exporting: 'Wird exportiert...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Drucken',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Entwurf',
      review: 'Prüfung',
      published: 'Veröffentlicht',
      selection: 'Auswahl',
      inTransit: 'Im Transport',
      completed: 'Abgeschlossen',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online-Instanz',
      message: 'Nur-Lesen-Modus. Daten werden vom primären Server synchronisiert.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Sie betrachten als',
      loggedInAs: 'angemeldet als {{nation}}',
      returnTo: 'Zurück zu {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Seiten, Anfragen, Transporte suchen...',
      searching: 'Suche läuft...',
      noResults: 'Keine Ergebnisse für „{{query}}"',
      navigate: 'Navigieren',
      select: 'Auswählen',
      close: 'Schließen',
      pages: {
        dashboard: 'Dashboard',
        requests: 'Anfragen',
        transports: 'Transporte',
        map: 'Karte',
        myPatients: 'Meine Patienten',
        flowDiagram: 'Flussdiagramm',
        statistics: 'Statistiken',
        assets: 'Transportmittel',
        startPoints: 'Startpunkte / Hubs',
        treatmentFacilities: 'Behandlungseinrichtungen',
        users: 'Benutzer',
        settings: 'Einstellungen',
        auditLogs: 'Auditprotokoll',
        exerciseControl: 'Übungssteuerung',
        dataSync: 'Datensynchronisation',
        patientImport: 'Patientenimport',
        notifications: 'Benachrichtigungen',
        documentation: 'Dokumentation',
      },
      actions: {
        importPatientsJson: 'Patienten importieren (JSON)',
        importPatientsExcel: 'Patienten importieren (Excel)',
        importUsers: 'Benutzer importieren (Excel)',
        importAssetTemplates: 'Asset-Vorlagen importieren (Excel)',
        importDayTemplates: 'Tagesvorlagen-Einträge importieren (Excel)',
        exportRequests: 'Anfragen exportieren (Excel)',
        exportPatients: 'Patienten exportieren (Excel)',
        exportUsers: 'Benutzer exportieren (Excel)',
        exportCredentials: 'Zugangsdaten exportieren (PDF)',
        exportAuditExcel: 'Auditprotokoll exportieren (Excel)',
        exportAuditPdf: 'Auditprotokoll exportieren (PDF)',
        pagePatientImport: 'Seite Patientenimport',
        pageRequestDetail: 'Seite Anfragedetails',
        pageUsers: 'Seite Benutzerverwaltung',
        pageAssetTemplates: 'Seite Asset-Vorlagen',
        pageDayTemplates: 'Seite Tagesvorlagen',
        pageRequests: 'Seite Anfragenliste',
        pageAuditLogs: 'Seite Auditprotokoll',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sitzung läuft ab',
      message: 'Ihre Sitzung läuft in <strong>{{time}}</strong> ab. Bitte speichern Sie Ihre Arbeit und melden Sie sich erneut an, um fortzufahren.',
      dismiss: 'Schließen',
      logoutNow: 'Jetzt abmelden',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: '4 Zeitzonen auswählen',
      configure: 'Zeitzonen konfigurieren',
      reset: 'Zurücksetzen',
      apply: 'Anwenden',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Standort auswählen',
      latitude: 'Breitengrad',
      longitude: 'Längengrad',
      clickToSelect: 'Klicken Sie auf die Karte, um einen Standort auszuwählen',
    },
    // Modal
    modal: {
      close: 'Schließen',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Startseite',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Systemwartung',
    message: 'Das System wird für den nächsten Übungstag zurückgesetzt. Bitte warten Sie, bis der Vorgang abgeschlossen ist.',
    autoRefresh: 'Diese Seite wird automatisch aktualisiert, sobald das System wieder verfügbar ist.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Entwurf',
      planned: 'Geplant',
      active: 'Aktiv',
      inTransit: 'Im Transit',
      completed: 'Abgeschlossen',
      cancelled: 'Abgebrochen',
    },
    actions: {
      USER_LOGIN: 'Benutzeranmeldung',
      USER_LOGOUT: 'Benutzerabmeldung',
      USER_CREATED: 'Benutzer erstellt',
      USER_UPDATED: 'Benutzer aktualisiert',
      USER_DELETED: 'Benutzer gelöscht',
      REQUEST_CREATED: 'Anfrage erstellt',
      REQUEST_UPDATED: 'Anfrage aktualisiert',
      REQUEST_SUBMITTED: 'Anfrage eingereicht',
      REQUEST_PUBLISHED: 'Anfrage veröffentlicht',
      REQUEST_CLOSED: 'Anfrage geschlossen',
      REQUEST_COMPLETED: 'Anfrage abgeschlossen',
      OFFER_CREATED: 'Angebot erstellt',
      OFFER_UPDATED: 'Angebot aktualisiert',
      OFFER_ACCEPTED: 'Angebot angenommen',
      OFFER_DELETED: 'Angebot gelöscht',
      MISSION_CREATED: 'Mission erstellt',
      MISSION_UPDATED: 'Mission aktualisiert',
      MISSION_STATUS_UPDATED: 'Missionsstatus',
      MISSION_SPLIT: 'Mission geteilt',
      MISSION_DELETED: 'Mission gelöscht',
      COMMENT_CREATED: 'Kommentar erstellt',
      TRANSPORT_CREATED: 'Transport erstellt',
      TRANSPORT_COMPLETED: 'Transport abgeschlossen',
      SELECTION_STARTED: 'Auswahl gestartet',
      SELECTION_ENDED: 'Auswahl beendet',
      FILE_UPLOADED: 'Datei hochgeladen',
      PATIENT_IDS_UPDATED: 'Patienten-IDs aktualisiert',
      SCHEDULE_CREATED: 'Zeitplan erstellt',
      BOOKING_CREATED: 'Buchung erstellt',
      EXERCISE_DAY_ACTIVATED: 'Tag aktiviert',
      EXERCISE_DAY_RESET: 'Tag zurückgesetzt',
      SETTING_UPDATED: 'Einstellung aktualisiert',
      PATIENTS_IMPORTED: 'Patienten importiert',
      PATIENTS_EXCLUDED: 'Patienten ausgeschlossen',
      PATIENTS_ADDED: 'Patienten hinzugefügt',
      REQUEST_DELETED: 'Anfrage gelöscht',
      REQUEST_REVERTED_TO_DRAFT: 'Zurück zum Entwurf',
    },
    transportMode: {
      SEATED: 'Sitzend',
      LYING: 'Liegend',
      TBA: 'Noch festzulegen',
    },
    dependency: {
      LOW: 'Niedrig',
      MEDIUM: 'Mittel',
      HIGH: 'Hoch',
      TBA: 'Noch festzulegen',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System-Gesundheits-Dashboard',
    unableToLoad: 'Gesundheitsdaten konnten nicht geladen werden',
    retry: 'Erneut versuchen',
    refresh: 'Aktualisieren',
    refreshFailed: 'Aktualisierung fehlgeschlagen',
    auto: 'Auto',
    manual: 'Manuell',
    disableAutoRefresh: 'Auto-Aktualisierung deaktivieren',
    enableAutoRefresh: 'Auto-Aktualisierung aktivieren (30s)',
    systemOverview: 'Systemübersicht',
    uptime: 'Betriebszeit',
    memory: 'Speicher',
    dbLatency: 'DB-Latenz',
    serverTime: 'Serverzeit',
    activityToday: 'Aktivität heute',
    activeNations: 'Aktive Nationen',
    requestsCreated: 'Erstellte Anfragen',
    patients: 'Patienten',
    missionsCreated: 'Erstellte Missionen',
    servicesStatus: 'Dienststatus',
    requestPipeline: 'Anfrage-Pipeline',
    noRequests: 'Keine Anfragen',
    staleDrafts: 'Veraltete Entwürfe (>24h)',
    reviewBottleneck: 'Prüfungsengpass (>48h)',
    publishedNoOffers: 'Veröffentlicht ohne Angebote',
    dataConsistency: 'Datenkonsistenzprüfungen',
    overallStatus: 'Gesamtstatus',
    healthy: 'Gesund',
    warnings: 'Warnungen',
    critical: 'Kritisch',
    check: 'Prüfung',
    issues: 'Probleme',
    noConsistencyChecks: 'Keine Konsistenzprüfungen verfügbar',
    databaseRecords: 'Datenbankeinträge',
    exerciseStatus: 'Übungsstatus',
    activeDay: 'Aktiver Tag',
    noActiveDay: 'Kein aktiver Tag',
    templates: 'Vorlagen',
    lastActivation: 'Letzte Aktivierung',
    never: 'Nie',
    recentAuditLog: 'Aktuelles Auditprotokoll',
    last10: 'Letzte 10',
    timestamp: 'Zeitstempel',
    user: 'Benutzer',
    action: 'Aktion',
    resource: 'Ressource',
    noRecentAudit: 'Keine aktuellen Auditeinträge',
    justNow: 'gerade eben',
    services: {
      database: 'Datenbank',
      email: 'E-Mail',
      sync: 'Synchronisation',
      notifications: 'Benachrichtigungen',
      maintenanceMode: 'Wartungsmodus',
      trainingMode: 'Übungsmodus',
      connectionFailed: 'Verbindung fehlgeschlagen',
      enabledSmtp: 'Aktiviert & SMTP konfiguriert',
      enabledNoSmtp: 'Aktiviert aber OHNE SMTP',
      disabled: 'Deaktiviert',
      staleUnread: '{{count}} veraltete ungelesene (>7T)',
      active: 'AKTIV',
      off: 'Aus',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Mindestens 10 Zeichen',
    uppercase: '1 Großbuchstabe',
    lowercase: '1 Kleinbuchstabe',
    digit: '1 Ziffer',
    special: '1 Sonderzeichen',
  },
};

export default de;
